<template>
  <v-container class="fill-height" fluid>
    <v-row>
      <v-col cols="12"
        :class="$style.centered"
      >
        <h2 :class="$style.headingLarge">Ta stran ne obstaja</h2>
        <p class="text-large"
          :class="$style.textLarge"
        >
          Uuuuups, nismo našli strani, ki jo iščete. Lahko se vrnete
          <router-link :to="{name: 'Home'}">
            na prvo stran.
          </router-link>
        </p>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  created () {
    this.$emit('ready')
  }
}
</script>

<style module>
  .headingLarge {
    font-size: 50px;
  }
  .textLarge {
    font-size: 25px;
    font-weight: 100;
  }
  .centered {
    text-align: center;
  }
</style>
